
import { Dialog } from "@/components/ui/dialog";
import { AddItemProvider } from "@/context/addItem";
import AddItemModal from "./AddItemModal";
import { AddItemModalProps } from "@/types/inventory";

const AddItemModalWrapper = ({
  open,
  onOpenChange,
  onAddItem,
  onItemAdded,
}: AddItemModalProps) => {
  return (
    <AddItemProvider
      open={open}
      onOpenChange={onOpenChange}
      onAddItem={onAddItem}
      onItemAdded={onItemAdded}
    >
      <Dialog open={open} onOpenChange={onOpenChange}>
        <AddItemModal />
      </Dialog>
    </AddItemProvider>
  );
};

export default AddItemModalWrapper;
